$(function() {
    'use strict';
    const trackingUtils = require('../modules/utils/tracking.utils');
    const CMP = require('@edreamsodigeo/frontend-cmp-client');
    const {thirdPartyTracking, initTrackingAgent} = require('@edreamsodigeo/frontend-tracking-agent');

    const {
        createCustomDimensionsRepository,
        createThirdPartyTrackingAgent,
        createTrackingParamsRepository,
        trackGAPage,
    } = thirdPartyTracking;

    function getWebmasterPageName() {
        const path = document.location.pathname.replace(Odigeo.Settings.getProperty('appContext'), '');
        return path.replace(/^\/+|\/+$/g, '');
    }

    Odigeo.defineWidget('googleanalytics', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            currentVirtualPage: null,
            // correspondences between pages and category used in event tracking
            eventTrackingCategoryDictionary: {
                'home': {
                    '': 'home',
                    '/': 'home',
                    'home': 'home',
                    'flights/dates': 'home',
                    'flights/departure0': 'home',
                    'flights/departure1': 'home',
                    'flights/departure2': 'home',
                    'flights/departure3': 'home',
                    'flights/departure4': 'home',
                    'flights/departure5': 'home',
                    'flights/destination0': 'home',
                    'flights/destination1': 'home',
                    'flights/destination2': 'home',
                    'flights/destination3': 'home',
                    'flights/destination4': 'home',
                    'flights/destination5': 'home',
                    'flights/passengers': 'home',
                    'myinfo': 'static_myinfo',
                    'settings': 'static_settings',
                    'mytrips': 'static_mytrips',
                    'about': 'static_about',
                    'contact': 'static_contact',
                    'securedcontact': 'static_contact',
                    'masthead': 'static_masthead',
                    'terms': 'static_terms',
                    'error': 'static_error',
                    'header': 'header',
                    'register': 'sso_register',
                    'accountblocked': 'sso_blocked',
                    'resetpassword': 'sso_change_pwd',
                    'frequentpassengers': 'sso_frequent_passengers',
                    'accountcreditcards': 'sso_account_credit_cards',
                    'accountpreferences': 'sso_account_preferences',
                    'xsellproductselection': 'intermediate_page',
                    'xsellproductselectionmetas': 'intermediate_page_metas',
                    'android_app_layer': 'android_app_layer',
                    'iphone_app_layer': 'iphone_app_layer',
                    'android_app_banner': 'android_app_banner',
                    'iphone_app_banner': 'iphone_app_banner',
                    'filters': 'intermediate_page',
                },
                'hotels': {
                    '': 'hotels_tab',
                    '/': 'hotels_tab',
                    'home': 'hotels_tab',
                    'header': 'hotels_tab',
                    'sso_module': 'hotels_tab',
                },
                'dp': {
                    '': 'dynpack_tab',
                    '/': 'dynpack_tab',
                    'home': 'dynpack_tab',
                    'header': 'dynpack_tab',
                    'notification_center': 'dynpack_tab',
                    'sso_module': 'sso_module',
                    'dpresults': 'dynpack_results',
                    'roomselection': 'dynpack_room_selection',
                    'flights_results': 'dynpack_flight_results',
                    'details-extras': 'dynpack_pax_page',
                    'details': 'dynpack_pax_page',
                    'passengersinfo': 'dynpack_pax_page',
                    'payment': 'dynpack_pay_page',
                    'ancillaries': 'dynpack_ancillaries_page',
                    'confirmation': 'dynpack_confirmation_page',
                    'flights_confirmation_page': 'dynpack_confirmation_page',
                    'flights_confirmation_page_confirmed': 'dynpack_confirmation_page_confirmed',
                    'flights_confirmation_page_rejected': 'dynpack_confirmation_page_rejected',
                    'flights_confirmation_page_pending': 'dynpack_confirmation_page_pending',
                    'flights_pax_page': 'dynpack_pax_page',
                    'flights_pay_page': 'dynpack_pay_page',
                    'flights_ancillaries_page': 'dynpack_ancillaries_page',
                    'flights_canxself_page': 'dynpack_canxself_page',
                    'flights_insurance_page': 'dynpack_insurance_page',
                    'flights_so_page': 'dynpack_so_page',
                    'dynpack_hotel_results': 'dynpack_hotel_results',
                    'dpresults_accommodation': 'dynpack_hotel_results',
                    'filters': 'dynpack_hotel_results',
                    'filter': 'dynpack_flight_results',
                    'insurance': 'dynpack_insurance_page',
                    'insurances': 'dynpack_insurance_page',
                    'booking': 'summary',
                    'dpresults_accommodation_details': 'dynpack_room_selection',
                    'servicepack': 'dynpack_so_page',
                },
                'flights': {
                    '': 'flights_tab',
                    '/': 'flights_tab',

                    /*
                     * Todo: SYRTOF-3409
                     * Refactor mobile.handler.home.js routers.
                     * Now when selecting city or date on mobile version
                     * Google analytics can't detect page category of the page.
                     * After refactoring delete the line below: 'flight': 'home'
                     */
                    'flights': 'home',

                    'home': 'flights_tab',
                    'header': 'flights_tab',
                    'notification_center': 'flights_tab',
                    'sso_module': 'flights_tab',
                    'xsellproductselection': 'intermediate_page',
                    'xsellproductselectionmetas': 'intermediate_page_metas',
                    'filters': 'intermediate_page',
                    'flightsummary': 'flights_summary',
                    'flightinfo': 'flights_info',
                    'insurance': 'flights_insurance_page',
                    'insurances': 'flights_insurance_page',
                    'flex': 'flights_flex_page',
                    'servicepack': 'flights_so_page',
                    'details-extras': 'flights_pax_page',
                    'results': 'flights_results',
                    'filter': 'flights_results',
                    'details': 'flights_pax_page',
                    'passengersinfo': 'flights_pax_page',
                    'ancillaries': 'flights_ancillaries_page',
                    'canx': 'flights_canxself_page',
                    'payment': 'flights_pay_page',
                    'confirmation': 'flights_confirmation_page',
                    'flights_confirmation_page_confirmed': 'flights_confirmation_page_confirmed',
                    'flights_confirmation_page_rejected': 'flights_confirmation_page_rejected',
                    'flights_confirmation_page_pending': 'flights_confirmation_page_pending',
                    'resident': 'flights_residents_page',
                    'android_app_layer': 'android_app_layer',
                    'iphone_app_layer': 'iphone_app_layer',
                    'android_app_banner': 'android_app_banner',
                    'iphone_app_banner': 'iphone_app_banner',
                    'my_area_trips': 'my_area_trips',
                    'my_area_trips_details': 'my_area_trips_details',
                    'trip_summary': 'trip_summary',
                    'accommodation_details': 'intermediate_room_selection',
                    'flights_results': 'flights_results',
                    'roomselection': 'room_selection',
                },
                'cms': {
                    '': getWebmasterPageName(),
                    '/': getWebmasterPageName(),
                    'home': getWebmasterPageName(),
                },
                'trackingTool': {
                    'home': 'home',
                },
                'deals': {
                    '': 'prime/deals',
                    '/': 'prime/deals',
                },
            },

            pageVirtualApplicationDictionary: {
                '': 'home',
                'dpresults': 'results',
                'roomselection': 'room-selection',
                'flex': 'flex_page',
                'canx': 'cancellation-guarantee',
                'ancillaries/canx': 'cancellation-guarantee',
                'deals': 'prime/deals',
            },

            // contains all virtual pages that should have /flights/ prefix when they are tracked
            appPages: ['', '/', 'home', 'flights', 'results', 'flights-results', 'hotel-results', 'room-selection',
                'edit', 'flights-filter', 'hotel-filter', 'summary', 'flightinfo', 'dp-upsell', 'dp-upsell-meta', 'cancellation-guarantee',
                'flex_page', 'insurances', 'service_options', 'details-extras', 'details', 'passengersinfo', 'payment',
                'confirmation', 'resident', 'redirection-3dsecure'],

            // Initialize Google Analytics Universal
            init: function() {
                const configParametersTrackingAgent = {
                    googleAnalytics: {
                        endpoint: {
                            defaultCustomDimensions: Odigeo.Settings.property('trackingServiceUrlFormatter')('ua/customDimensions'),
                            pageCustomDimensions: null,
                        },
                        selfReferrals: Odigeo.SessionScope.selfReferrals,
                        ga4GroupId: Odigeo.SessionScope.ga4GroupId,
                    },
                    datamesh: {
                        context: '/frontend-home',
                    },
                    generic: {
                        visitID: Odigeo.SessionScope.visitId,
                        storageClient: CMP.createStorageClient(Odigeo.SessionScope.brand, Odigeo.SessionScope.locale),
                        isNativeInterface: Odigeo.SessionScope.isNativeInterface,
                        dapiSessionId: undefined,
                        locale: Odigeo.SessionScope.locale,
                        flow: Odigeo.SessionScope.flow,
                        device: Odigeo.Device.navigator.isIOSWebView ? 'IOS_' : 'ANDROID_',
                        brand: Odigeo.SessionScope.brand,
                        website: Odigeo.SessionScope.website,
                        abs: [{
                            name: 'QUALTRICS_TMS',
                            value: Odigeo.AB.getQualtricsTms,
                        }, {
                            name: 'TMS_RECOVERY',
                            value: Odigeo.AB.getTmsRecovery,
                        }],
                    },
                };

                initTrackingAgent(configParametersTrackingAgent);
                this.options = Odigeo.parseOptions(this.widget.options);
                Odigeo.trigger('google-analytics:constructed');
            },

            allowAdFeatures: function(adFeaturesAllowed) {
                this.gtagWrapper('set', 'allow_ad_personalization_signals', adFeaturesAllowed);
                trackingUtils.setCustomDimension(66, adFeaturesAllowed.toString());
            },

            gtagWrapper: function() {
                if (!window || !window.gtag) {
                    return;
                }
                window.gtag.apply(this, arguments);
            },

            // EVENT TRACKING
            /**
             * @function
             * @param {object} data
             * @param {object} data.category on dp product is a hash to access category name by eventTrackingCategoryDictionary
             * @param {object} data.action
             * @param {object} data.label
             * @param {object} data.page (optional) This property is used when GAP category parameter
             * @param {object} data.value (optional) A value of undefined ignores the option. See link below.
             * should be determined based in the page where event occurs
             * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEventTracking#_gat.GA_EventTracker_._trackEvent
             */
            trackEvent: function(data) {
                const thirdPartyTrackingAgent = createThirdPartyTrackingAgent({});
                const app = Odigeo.Utils.isWebmasterPage() ? 'cms' : Odigeo.Utils.getAppInGlobalScope();
                const category = this._getCategory(data, app);
                const page = this.currentVirtualPage;
                const label = data.label;
                const action = data.action;
                const dimensionsAndParams = {...this.customDimensions};
                thirdPartyTrackingAgent.trackEvent({
                    page,
                    category,
                    action,
                    label,
                    dimensionsAndParams,
                });
            },

            processMetasPage: function(data) {
                const suffix = !_.isEmpty(Odigeo.Session.get('isMetaForIntermediate')) ? 'metas' : '';

                return (data.page === 'xsellproductselection') ? data.page + suffix : data.page;
            },

            /**
             * It calculates category based on app, data.page and data.category
             * @function
             * @param {object} data
             * @param {object} app
             * @return {string}
             */
            _getCategory: function(data, app) {
                app = app === 'upsell' ? 'dp' : app;
                const page = this.processMetasPage(data);
                const isHotelsOrDynpackWithCategory = ((app === 'dp' || app === 'hotels') && !_.isUndefined(data.category));
                const response = isHotelsOrDynpackWithCategory ? this.eventTrackingCategoryDictionary[app][data.category] :
                    (!_.isUndefined(page) && !_.isUndefined(this.eventTrackingCategoryDictionary[app]) ?
                        this.eventTrackingCategoryDictionary[app][page] : data.category);
                return !_.isUndefined(response) ? response : data.category;
            },

            /**
             * @function
             * @param {object} data
             * @param {object} data.url
             */
            sendToPageSelf: function(data) {
                let url = data.url;
                data.goOutside = (_.isUndefined(data.goOutside)) ? (this.prepareLinkToTrackCrossDomain(url) !== url) : data.goOutside;
                if (data.goOutside) {
                    document.location = url;
                } else {
                    document.location = data.url;
                }
            },

            /**
             * @function
             * @param {object} data
             * @param {object} data.url
             */
            sendToPageBlank: function(data) {
                if (data.goOutside) {
                    window.open(this.prepareUrlToTrackCrossDomain(data.url));
                } else {
                    window.open(data.url);
                }
            },


            isWaitingPage: function(page) {
                return /^waiting(\/\d|-3dsecure)$/g.test(page);
            },

            _getFunnel: function(page, funnelParam) {
                const funnelInGlobalScope = Odigeo.Utils.getFunnelInGlobalScope();
                const isWebmasterPage = Odigeo.Utils.isWebmasterPage();
                const isAppPages = _.indexOf(this.appPages, page) > -1 && !_.isUndefined(funnelInGlobalScope);
                const hardFunnel = (typeof funnelParam === 'string' && funnelParam !== '') && funnelParam;
                const defaultFunnel = funnelParam === true && 'flights';
                const scopeFunnel = !isWebmasterPage && (isAppPages || this.isWaitingPage(page)) && funnelInGlobalScope;

                const funnel = hardFunnel || scopeFunnel || defaultFunnel;

                return funnel ? funnel + '/' : '';
            },

            _getPage: function(data) {
                if (Odigeo.Utils.isWebmasterPage()) {
                    return getWebmasterPageName();
                } else {
                    return this.pageVirtualApplicationDictionary[data.page] || data.page;
                }
            },

            // VIRTUAL PAGES TRACKING
            /**
             * @function
             * @param {object} data
             * @param {object} data.funnel Boolean. Indicates if virtual page belongs to funnel or not
             * @param {object} data.page String that represents page name
             * @param {object} data.error This property is present only if an error ocurred into tracked page
             * @param {object} data.error.type 2 error types have been considered: popin (when a dialog appear) and default
             * @param {object} data.error.message Error message to be tracked
             * @param {object} data.customVar (optional) Track this page using a non default customVar.
             *                 After tracking is done, default customVar is set again.
             */
            trackVirtualPage: function(data) {
                this.trackInTrackingSystem(data);
                this.trackVirtualPageInUniversal(data);
            },

            _generatePageviewUniversal: function(data) {
                const virtualFunnel = data.funnel ? '/BF' : '';
                const page = this._getPage(data);
                const funnelPage = this._getFunnel(page, data.funnel);
                const virtualError = (!_.isUndefined(data.error) ?
                    (data.error.type === 'popin' ? '-popin-error' : '_error_' + data.error.message) : '');

                return virtualFunnel + '/' + funnelPage + page + virtualError + '/';
            },

            trackVirtualPageInUniversal: function(data) {
                const virtualPage = this._generatePageviewUniversal(data);
                this.currentVirtualPage = virtualPage;
                const options = {
                    customDimensions: {...this.customDimensions,
                        ...data.customDimensions},
                    error: data.error,
                    eCommerce: null,
                    funnel: data.funnel,
                };
                trackGAPage(virtualPage, options);
            },

            trackInTrackingSystem: function(data) {
                const isMobile = Odigeo.SessionScope.flow === 'mobile';
                const toolPageName = this._getPageNameForTrackingTool(data.page, isMobile);
                const url = Odigeo.Settings.options.trackingToolServiceFormatter('trackPageView') + '/' + toolPageName;
                if (toolPageName) {
                    $.ajax({
                        url: url,
                        method: 'POST',
                    });
                }
            },

            _getPageNameForTrackingTool: function(page, isMobile) {
                let word;
                const dictionary = this.eventTrackingCategoryDictionary['trackingTool'];
                // Los indices de la waiting para mobile y desktop son diferentes
                if (isMobile && page.indexOf('waiting') > -1) {
                    word = dictionary['sm/' + page];
                } else {
                    word = dictionary[page];
                }
                return word || '';
            },

            setCustomDimension: function(params) {
                const customDimensionsRepository = createCustomDimensionsRepository();
                customDimensionsRepository.set(params);
            },

            trackCustomVariable: function(params) {
                if (params.customDimension) {
                    this.setCustomDimension(params);
                }
            },

            trackPromo: function(data) {
                const thirdPartyTrackingAgent = createThirdPartyTrackingAgent({});
                thirdPartyTrackingAgent.trackPromotion({
                    promo: data.promo,
                    isClick: data.isClick,
                    index: data.index,
                });
            },

            /**
             * @function
             * @description This method works in conjunction with the _setDomainName() and _setAllowLinker()
             * methods to enable cross-domain user tracking
             * specifically for iFrames and links that open in a new window.
             * This method returns a string of all the
             * <a href="https://developers.google.com/analytics/resources/concepts/gaConceptsCookies">GATC cookie</a>
             * data from the initiating link by appending it to the URL parameter.
             * This can then be passed on to a another site or iFrame.
             * @param {string} url
             * @return {string} url with GATC cookide data appended.
             */
            prepareUrlToTrackCrossDomain: function(url) {
                return url;
            },

            prepareLinkToTrackCrossDomain: function(url) {
                const mainDomain = this.options.mainDomain;
                const linkDomain = this.extractDomain(url);
                const crossDomainExceptions = this.options.crossDomainExceptions;
                const crossDomainExceptionsArray = _.isArray(crossDomainExceptions) ? crossDomainExceptions : new Array(crossDomainExceptions);

                return (mainDomain !== linkDomain && !_.includes(crossDomainExceptionsArray, linkDomain)) ?
                    this.prepareUrlToTrackCrossDomain(url) : url;
            },

            extractDomain: function(url) {
                let domain;
                domain = ((url.indexOf('://') > -1) ? url.split('/')[2] : url.split('/')[0]).split(':')[0];
                return (domain.indexOf('www') > -1) ? domain.split('www.')[1] : domain;
            },

            addCrossDomainIframeTracking: function(iFrame) { },

            getMktportalParams: function() {
                return {mktportal: Odigeo.Utils.readCookie('mktportal') || ''};
            },

            decorateAppTouchpointUrl: function(url) {
                const trackingParamsRepository = createTrackingParamsRepository();
                const utmParams = trackingParamsRepository.getUtmParams();
                const params = _.assign({},
                    utmParams,
                    this.getMktportalParams()
                );

                const paramStr = _.map(params, function(value, key) {
                    return key + '=' + value;
                }).join('&');

                return url.replace('{TRACKING_PARAMS}', encodeURIComponent(paramStr));
            },
        }),

        exposedMethods: [
            'trackEvent',
            'sendToPageSelf',
            'sendToPageBlank',
            'trackVirtualPage',
            'trackCustomVariable',
            'setCustomDimension',
            'trackPromo',
            'prepareUrlToTrackCrossDomain',
            'prepareLinkToTrackCrossDomain',
            'addCrossDomainIframeTracking',
            'decorateAppTouchpointUrl',
        ],

        execute: function(fn) {
            let result;
            if (_.includes(this.exposedMethods, fn) && _.isFunction(this.model[fn])) {
                const args = [].slice.call(arguments, 1);
                result = this.model[fn].apply(this.model, args);
            }
            return !_.isUndefined(result) ? result : this;
        },

        getDecoratedAppTouchpointUrl: function(url) {
            return this.model.decorateAppTouchpointUrl(url);
        },
    }));
});
